import { NLink } from 'nayan';
import { CONFIG } from '../../config/Config.ts';

const Banner = () => {
  return (
    <section className="bg-card flex items-center justify-center overflow-hidden" id="home">
      <div className="container mx-auto">
        <div className="grid md:grid-cols-2 grid-cols-1 gap-8">
          <div className="flex flex-col justify-center md:p-0 py-5 px-3">
            <div className="text-3xl mb-5 text">Kids Smart Learning Application</div>
            <div className="text-base leading-loose mb-5 text">
              Kidster is a fun and engaging smart learning app designed for kids, featuring pictorial learning, interactive stories, brain-boosting
              puzzles, and educational games. It offers a playful environment that makes learning enjoyable, helping children develop essential skills
              through visuals and interactive content.
            </div>
            <div className="flex flex-row items-center p-0">
              <NLink href={CONFIG.PLAY_STORE_URL}>
                <img src="/play-store.png" className="h-[50px] w-auto" alt="Inyter app google play store download" width="250" height="120" />
              </NLink>
              {/*<NLink href={CONFIG.PLAY_STORE_URL} target="_blank" className="ml-3">*/}
              {/*  <img className="h-[50px] w-auto" src="/app-store.png" alt="Worklage app store" />*/}
              {/*</NLink>*/}
            </div>
          </div>
          <div className="p-5 flex justify-center items-center">
            <img src="/kidster-kids.png" alt="kidster logo" className="w-full h-full max-w-[450px]" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Banner;
